export default __webpack_public_path__ + "static/media/icon2.deec394e.png";